export default "__VITE_ASSET__CjBxuUAh__"